module.exports = __webpack_public_path__ + "static/media/131-chile.0347f894.svg";